import { gql } from '@apollo/client';

export const GET_NEWS_FOR_MANAGER = gql(`
  query getNewsForManager {
    navigation_manager {
      ... on navigation_manager {
        id
        news {
          id
          titel
          inhalt
          veroeffentlichtAm
          istGelesen
          bildUrl
        }
      }
      ... on navigation_genericError {
        message
      }
    }
  }
`);
